export enum EVENTS {
    USER_JOINED = "USER_JOINED",
    USER_REQUEST_ONLINE_PLAN_PERFORMANCES = "USER_REQUEST_ONLINE_PLAN_PERFORMANCES",
    USER_GOT_ONLINE_PLAN_PERFORMANCES = "USER_GOT_ONLINE_PLAN_PERFORMANCES",
    USER_CHANGE_COMPLETED_PLAN = "USER_CHANGE_COMPLETED_PLAN",
    USER_CHANGED_COMPLETED_PLAN = "USER_CHANGED_COMPLETED_PLAN",
}
